import { COLORS, SIZES } from 'src/styles/theme'
import styled from 'styled-components'

export const LoginPageStyle = styled.section`
  position: fixed;
  top: 22%;
  bottom: 36%;
  right: 10%;
  left: 10%;
  padding: 4vw;
  padding-bottom: 0;
  max-height: 100%;
  text-align: center;
  color: white;

  .action-text {
    font-weight: bold;
    color: #ff9821;
    cursor: pointer;
  }

  form {
    color: #404040;
    padding: 30px 10px;
    border-radius: 28px;
    margin: auto;
    margin-top: 30px;
    max-width: 375px;

    input {
      width: 100%;
      background: #ffffff;
      border: none;
      padding: 12px 28px;
      border-radius: 20px;
      margin-top: 20px;

      &::placeholder {
        color: #bc1b27;
      }
    }

    .forget-pass {
      width: 80%;
      color: ${COLORS.primaryTrans};
      margin-top: 10px;
      font-size: 0.9em;
    }

    .login-btn {
      background: linear-gradient(#da2a3a, #ac1723);
      box-shadow: 0 5px 4px -4px #000000;
      width: 40%;
      color: #ffffff;
      font-weight: 500;
      border: 3px solid #ffffff;
      border-radius: 56px;
      display: flex;
      justify-content: center;
      padding: 8px 24px;
      margin: 16px auto;
      margin-bottom: 0;
      font-size: 1em;
      outline: none;
      input {
        cursor: pointer;
        opacity: 0;
        padding: 0;
        margin: 0;
        display: none;
      }
    }
    .title {
      font-weight: 700;
      font-size: 20px;
      margin: 0;
      color: #ffffff;
      text-align: center;
    }
    .white-arrow {
      width: 24px;
      line-height: 60px;
      cursor: pointer;
    }
  }

  div.privacy {
    margin: 0 auto;
    width: 90%;
    margin-top: 12px;

    .readMore {
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .form-check {
    display: flex;
    align-items: flex-start;
    padding: 0;
    font-weight: 500;
    .agree-box {
      padding: 8px;
      margin-top: 4px;
      width: 20%;
    }
    .form-check-label {
      color: #404040;
      font-size: 11px;
      margin-left: 8px;
      a {
        text-decoration: underline;
      }
    }
  }

  #support-link {
    font-size: 11px;
    text-decoration: underline;
  }

  ${SIZES.mobile} {
    /* position: static; */
    /* padding: 20% 10px; */
    /* min-height: 100vh;
  max-height: auto; */
    /* left: 50%;
  transform: translateX(-50%); */

    form {
      border-radius: 10px;
    }
  }
`
